import { useEffect, useRef } from 'react';

import type { Invoice } from '~/data/schemas/invoice';
import useLAISnackbar from '~/hooks/useLAISnackbar';

import { useStampedInvoice } from './useStampedInvoice';

interface StampedInvoiceDownloaderProps {
  invoice: Invoice;
  includeSupportingData: boolean;
  onComplete: () => void;
}

export function StampedInvoiceDownloader({
  invoice,
  includeSupportingData,
  onComplete,
}: StampedInvoiceDownloaderProps) {
  const { downloadStampedInvoice } = useStampedInvoice({ invoice });
  const { showSnackbar } = useLAISnackbar();
  const hasTriggered = useRef(false);

  useEffect(() => {
    if (hasTriggered.current) return;
    hasTriggered.current = true;

    downloadStampedInvoice({ includeSupportingData })
      .catch(() => {
        showSnackbar('Failed to download stamped invoice. Please try again.', {
          variant: 'error',
        });
      })
      .finally(onComplete);
  }, [downloadStampedInvoice, includeSupportingData, onComplete, showSnackbar]);

  return null;
}
